// extracted by mini-css-extract-plugin
module.exports = {"priceItem":"summary_priceItem__1UGuw","remaining":"summary_remaining__zkvU3","total":"summary_total__4Useu","lineItem":"summary_lineItem__oUXV6","divider":"summary_divider__HDPCS"};